import { VISUAL_ASSORTMENT } from 'routes/paths'

import DropdownMenuTextLink from 'features/Navbar/NavbarRevamp/components/DropdownMenuTextLink/DropdownMenuTextLink'
import messages from 'features/Navbar/NavbarRevamp/constants/navbarRevamp.messages'

export const VisualAssortmentLink = ({
  hasAccountAccess = false,
}: {
  hasAccountAccess?: boolean
}) => {
  return (
    <DropdownMenuTextLink
      to={VISUAL_ASSORTMENT}
      message={messages.visualAssortment}
      {...(!hasAccountAccess && { iconName: 'unlock' })}
    />
  )
}
